import { forwardRef } from 'react'
import ReactDOM from 'react-dom'

import { useCreatePortalRoot } from '../../hooks'
import { AttachmentBarProps, AttachmentBarRef } from './AttachmentBar.types'
import { AttachmentBarContent } from './AttachmentBarContent'

const ROOT_ID = 'attachmentBar'

const AttachmentBar = forwardRef<AttachmentBarRef, AttachmentBarProps>(
  (
    {
      children,
      filter,
      footer,
      closeOnOutsideClick = false,
      onClose,
      hasTransitionAnimation = false,
      resizable = false,
      resizeMinWidth,
      resizeMaxWidth,
      resizeStorageKey,
      rightOffset,
      screenHasSecondaryMenu = false,
      shouldOverlayContent = false,
      shouldHideHeader,
      shouldRenderWithoutPortal,
      style,
      title,
      width,
    },
    ref,
  ) => {
    const renderAttachmentBar = () => {
      return (
        <AttachmentBarContent
          ref={ref}
          title={title}
          footer={footer}
          closeOnOutsideClick={closeOnOutsideClick}
          onClose={onClose}
          filter={filter}
          hasTransitionAnimation={hasTransitionAnimation}
          resizable={resizable}
          resizeMinWidth={resizeMinWidth}
          resizeMaxWidth={resizeMaxWidth}
          resizeStorageKey={resizeStorageKey}
          rightOffset={rightOffset}
          screenHasSecondaryMenu={screenHasSecondaryMenu}
          shouldOverlayContent={shouldOverlayContent}
          shouldHideHeader={shouldHideHeader}
          style={style}
          width={width}
        >
          {children}
        </AttachmentBarContent>
      )
    }

    const portalRoot = useCreatePortalRoot({ rootId: ROOT_ID, disabled: shouldRenderWithoutPortal })

    if (shouldRenderWithoutPortal) {
      return renderAttachmentBar()
    }

    if (!portalRoot) {
      return null
    }

    return ReactDOM.createPortal(renderAttachmentBar(), portalRoot)
  },
)

export { AttachmentBar }
